import {Table} from 'reactstrap';
import {Marina, Loader, Translation, MoneyInput} from 'marine-panel-common-web';
import {
    changeExtraOrder,
    changeIsMarinaEditWizardLoading,
    fetchMarinaDetails,
    IChangeExtraOrder,
    IChangeExtraOrderItem,
    IRemoveExtra,
    removeExtra,
    resetToInitialMarinaEditWizardState,
} from '../../../../../../store/reducers/marinaEditWizardSlice';
import {connect} from 'react-redux';
import {useParams} from 'react-router-dom';
import {RootState} from '../../../../../../store/reducers';
import {useEffect} from 'react';
import {
    currentlyEditedMarina,
    isActionSuccessfulSelector,
    isMarinaEditWizardLoadingSelector,
    isMarinaEditWizardInitializedSelector,
} from '../../../../../../store/selectors/marinaEditWizardSelectors';
import {changeIsModalOpen, ModalNames, setCurrentlyEditedItemId, setModalName} from '../../../../../../store/reducers/modalSlice';
import DragDropTable from './DragDropTable';

export interface IExtra {
    id: string;
    name: string;
    description: string | null;
    price: MoneyInput | null;
}

interface IConnectedMarinaExtrasProps {
    readonly marina: Marina | null;
    readonly isLoading: boolean;
    readonly fetchMarinaDetails: typeof fetchMarinaDetails;
    readonly resetToInitialMarinaEditWizardState: typeof resetToInitialMarinaEditWizardState;
    readonly removeExtra: typeof removeExtra;
    readonly changeExtraOrder: typeof changeExtraOrder;
    readonly changeIsMarinaEditWizardLoading: typeof changeIsMarinaEditWizardLoading;
    readonly setCurrentlyEditedItemId: typeof setCurrentlyEditedItemId;
    readonly setModalName: typeof setModalName;
    readonly changeIsModalOpen: typeof changeIsModalOpen;
}

const MarinaExtras: React.FC<IConnectedMarinaExtrasProps> = ({
    marina,
    isLoading,
    fetchMarinaDetails,
    resetToInitialMarinaEditWizardState,
    changeIsMarinaEditWizardLoading,
    setCurrentlyEditedItemId,
    changeExtraOrder,
    removeExtra,
    setModalName,
    changeIsModalOpen,
}) => {
    const params = useParams(),
        marinaId = params.id;

    useEffect(() => {
        fetchMarinaDetails(marinaId ? marinaId : null);
        return () => {
            resetToInitialMarinaEditWizardState();
        };
    }, [marinaId, fetchMarinaDetails, resetToInitialMarinaEditWizardState]);
    function openCreateExtraModal() {
        setModalName(ModalNames.CREATE_EXTRA);
        changeIsModalOpen(true);
    }

    const removeExtraAction = (extraId: string) => {
        if (!marinaId) return null;
        const payload: IRemoveExtra = {
            marinaId: marinaId ? marinaId : '',
            payload: {
                extraId: extraId,
            },
        };
        changeIsMarinaEditWizardLoading(true);
        removeExtra(payload);
    };

    const changeExtraServicesOrder = (extrasList: IChangeExtraOrderItem[]) => {
        const payload: IChangeExtraOrder = {
            marinaId: marinaId ? marinaId : '',
            payload: extrasList,
        };
        changeExtraOrder(payload);
    };

    const openEditExtraModal = (extraId: string) => {
        setModalName(ModalNames.EDIT_EXTRA);
        changeIsModalOpen(true);
        setCurrentlyEditedItemId(extraId);
    };

    return (
        <div>
            <h1 className="title main">
                <Translation text="editMenuItems.sections.marina_extras.title" />
            </h1>
            <h2 className="title secondary">
                <Translation text="editMenuItems.sections.marina_extras.description" />
            </h2>
            <div className="d-flex justify-content-end mb-2">
                <button className="btn btn-create" onClick={() => openCreateExtraModal()}>
                    <Translation text="editMenuItems.sections.marina_extras.buttons.create" />
                </button>
            </div>
            <Table responsive>
                <thead>
                    <tr>
                        <th>
                            <Translation text="editMenuItems.sections.marina_extras.table.headers.name" />
                        </th>
                        <th>
                            <Translation text="editMenuItems.sections.marina_extras.table.headers.currentPrice" />
                        </th>
                        <th>
                            <Translation text="editMenuItems.sections.marina_extras.table.headers.actions" />
                        </th>
                    </tr>
                </thead>

                <DragDropTable
                    extras={marina?.extras}
                    openEditExtraModal={openEditExtraModal}
                    removeExtraAction={removeExtraAction}
                    changeExtraServiceOrder={changeExtraServicesOrder}
                />
            </Table>
            <Loader showLoader={isLoading} />
        </div>
    );
};

export default connect(
    (state: RootState) => ({
        marina: currentlyEditedMarina(state),
        isLoading: isMarinaEditWizardLoadingSelector(state),
        isActionSuccessful: isActionSuccessfulSelector(state),
        isGalleryMarinaComponentInitialized: isMarinaEditWizardInitializedSelector(state),
    }),
    {
        fetchMarinaDetails,
        removeExtra,
        resetToInitialMarinaEditWizardState,
        changeIsMarinaEditWizardLoading,
        setCurrentlyEditedItemId,
        changeExtraOrder,
        setModalName,
        changeIsModalOpen,
    }
)(MarinaExtras);
